// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1vI6J","itemTitle":"ClientEmergencyInfo_itemTitle__2Xv_3","itemText":"ClientEmergencyInfo_itemText__oAHsi"};